import React, { useEffect, useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Services from './components/Services';
import Hardware from './components/Hardware';
import Projects from './components/Projects';
import Paraguay from './components/Paraguay';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import CalculadoraPage from './pages/CalculadoraPage';
import ComingSoonPage from './pages/ComingSoonPage';
import ServicioResidencialPage from './pages/ServicioResidencialPage';
import ServicioEmpresasPage from './pages/ServicioEmpresasPage';
import ServicioRuralPage from './pages/ServicioRuralPage';
import CatalogoPage from './pages/CatalogoPage';
import MovilidadElectricaPage from './pages/MovilidadElectricaPage';
import LaboratorioInnovacionPage from './pages/LaboratorioInnovacionPage';
import ServicioInstalacionPage from './pages/ServicioInstalacionPage';
import SolucionesEcologicasPage from './pages/SolucionesEcologicasPage';
import GestoriaPage from './pages/GestoriaPage';
import HuellaCeroPage from './pages/HuellaCeroPage';
import AuditoriaEnergeticaPage from './pages/AuditoriaEnergeticaPage';
import InternetSatelitalPage from './pages/InternetSatelitalPage';
import AccionSocialPage from './pages/AccionSocialPage';
import SocialProjectDetailPage from './pages/SocialProjectDetailPage';
import FinanciamientoPropiaPage from './pages/FinanciamientoPropiaPage';
import FinanciamientoBancosPage from './pages/FinanciamientoBancosPage';
import CreditosVerdesPage from './pages/CreditosVerdesPage';
import BeneficiosFiscalesPage from './pages/BeneficiosFiscalesPage';
import FAQPage from './pages/FAQPage';
import GarantiasPage from './pages/GarantiasPage';
import ServicioTecnicoPage from './pages/ServicioTecnicoPage';
import HistoriaPage from './pages/HistoriaPage';
import MisionVisionPage from './pages/MisionVisionPage';
import SustentabilidadPage from './pages/SustentabilidadPage';
import TrabajaPage from './pages/TrabajaPage';
import NoticiasPage from './pages/NoticiasPage';
import NewsDetailPage from './pages/NewsDetailPage';
import EventosPage from './pages/EventosPage';
import EventDetailPage from './pages/EventDetailPage';
import SoporteNosotrosPage from './pages/SoporteNosotrosPage';
import PoliticaPrivacidadPage from './pages/PoliticaPrivacidadPage';
import TerminosServicioPage from './pages/TerminosServicioPage';
import AdminApp from './admin/AdminApp';

const HomePage = ({ isScrolled }) => {
  return (
    <>
      <Navigation isScrolled={isScrolled} />
      <main>
        <Hero />
        <Services />
        <Hardware />
        <Projects />
        <Paraguay />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </>
  );
};

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage isScrolled={isScrolled} />} />
          <Route path="/calculadora" element={<CalculadoraPage />} />
          
          {/* Productos */}
          <Route path="/productos/catalogo" element={<CatalogoPage />} />
          <Route path="/productos/movilidad-electrica" element={<MovilidadElectricaPage />} />
          <Route path="/productos/laboratorio" element={<LaboratorioInnovacionPage />} />
          
          {/* Servicios - Páginas principales */}
          <Route path="/servicios/residenciales" element={<ServicioResidencialPage />} />
          <Route path="/servicios/empresas" element={<ServicioEmpresasPage />} />
          <Route path="/servicios/rural-agro" element={<ServicioRuralPage />} />
          
          {/* Servicios - Otros */}
          <Route path="/servicios/instalacion" element={<ServicioInstalacionPage />} />
          <Route path="/servicios/ecologicas" element={<SolucionesEcologicasPage />} />
          <Route path="/servicios/gestoria" element={<GestoriaPage />} />
          <Route path="/servicios/huella-cero" element={<HuellaCeroPage />} />
          <Route path="/servicios/auditoria" element={<AuditoriaEnergeticaPage />} />
          <Route path="/servicios/internet" element={<InternetSatelitalPage />} />
          
          {/* Proyectos */}
          <Route path="/proyectos/privados" element={<ComingSoonPage pageName="Proyectos Privados" />} />
          <Route path="/proyectos/accion-social" element={<AccionSocialPage />} />
          <Route path="/proyectos/accion-social/:projectId" element={<SocialProjectDetailPage />} />
          
          {/* Financiamiento */}
          <Route path="/financiamiento/propia" element={<FinanciamientoPropiaPage />} />
          <Route path="/financiamiento/bancos" element={<FinanciamientoBancosPage />} />
          <Route path="/financiamiento/creditos-verdes" element={<CreditosVerdesPage />} />
          <Route path="/financiamiento/beneficios" element={<BeneficiosFiscalesPage />} />
          
          {/* Soporte */}
          <Route path="/soporte/faq" element={<FAQPage />} />
          <Route path="/soporte/garantias" element={<GarantiasPage />} />
          <Route path="/soporte/servicio-tecnico" element={<ServicioTecnicoPage />} />
          
          {/* Nosotros */}
          <Route path="/nosotros/soporte" element={<SoporteNosotrosPage />} />
          <Route path="/nosotros/historia" element={<HistoriaPage />} />
          <Route path="/nosotros/mision-vision" element={<MisionVisionPage />} />
          <Route path="/nosotros/sustentabilidad" element={<SustentabilidadPage />} />
          <Route path="/nosotros/trabaja" element={<TrabajaPage />} />
          <Route path="/nosotros/noticias" element={<NoticiasPage />} />
          <Route path="/noticias/:slug" element={<NewsDetailPage />} />
          <Route path="/nosotros/eventos" element={<EventosPage />} />
          <Route path="/eventos/:slug" element={<EventDetailPage />} />
          
          {/* Legal Pages */}
          <Route path="/politica-privacidad" element={<PoliticaPrivacidadPage />} />
          <Route path="/terminos-servicio" element={<TerminosServicioPage />} />
          
          {/* Admin Panel */}
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;